import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/ui-custom/PageHero";
import GlassCard from "../components/ui-custom/GlassCard";
import Reveal from "../components/ui-custom/Reveal";
import { powerQualityCategories } from "../data/mock";
import { getIcon } from "../data/iconMap";

const PowerQuality = () => {
  return (
    <div>
      <PageHero
        eyebrow="Power Quality"
        title="Power Quality"
        subtitle="Capacitor banks, harmonic filters, SVC & STATCOM systems that stabilise grids and enable smooth integration of renewable energy sources."
      />
      <section className="px-6 pb-28">
        <div className="max-w-6xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {powerQualityCategories.map((cat, i) => {
            const Icon = getIcon(cat.icon);
            return (
              <Reveal key={cat.slug} delay={i * 0.06}>
                <GlassCard tilt accent="amber" className="p-7 h-full flex flex-col">
                  {cat.image && (
                    <img
                      src={cat.image}
                      alt={cat.title}
                      loading="lazy"
                      className="w-full h-40 rounded-xl object-cover border border-qamber/20 mb-5"
                    />
                  )}
                  <span className="w-14 h-14 rounded-xl flex items-center justify-center bg-qamber/10 border border-qamber/25 mb-5">
                    <Icon size={26} className="text-qamber" />
                  </span>
                  <h3 className="font-display font-bold uppercase tracking-wide text-lg text-foreground mb-2">{cat.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed mb-6 flex-1">{cat.summary}</p>
                  <Link
                    to={`/power-quality/${cat.slug}`}
                    className="inline-flex items-center gap-2 text-qamber font-semibold text-sm tracking-wide hover:gap-3 transition-all"
                  >
                    View Details <ArrowRight size={16} />
                  </Link>
                </GlassCard>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default PowerQuality;
